import { t } from 'constants/reconciliationFormsI18n';

/** Every reconciliation carrier email includes these addresses in CC. */
export const RECONCILIATION_FORMS_ALWAYS_CC = [
  'commissionteam@sunshinelifehealth.com',
  'ricardolivingsecure@gmail.com'
];

function normalizeEmail(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

/**
 * Zoho `ccList` plus mandatory Sunshine CCs (deduped, fixed addresses first).
 */
export function getEffectiveCcList(row) {
  const seen = new Set();
  const out = [];
  for (const addr of RECONCILIATION_FORMS_ALWAYS_CC) {
    const n = normalizeEmail(addr);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(addr.trim());
  }
  for (const addr of row?.ccList || []) {
    const n = normalizeEmail(addr);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(String(addr).trim());
  }
  return out;
}

function isCommunityHealthChoice(name) {
  return /community\s*health\s*choice/i.test(String(name || ''));
}

function isOtherCarriersRow(row) {
  return row?.isOther === true;
}

function encodeMailtoValue(value) {
  return encodeURIComponent(value).replace(/%0A/g, '%0D%0A');
}

/**
 * mailto: link for a carrier row (Zoho subject/body when present).
 */
export function buildCarrierMailto(row, lang) {
  const to = (row.sendToEmail || '').trim();
  if (!to) return '';

  const ccList = getEffectiveCcList(row);
  const cc = ccList.length ? ccList.join(',') : '';

  const subject =
    (row.emailSubject && String(row.emailSubject).trim()) ||
    `Commission Reconciliation — ${row.carrierName} — [Month/Year] — Sunshine Life & Health Advisors`;

  let body = (row.emailMessage && String(row.emailMessage).trim()) || '';

  if (!body) {
    if (isOtherCarriersRow(row)) {
      body = t(lang, 'email.other.body');
    } else if (isCommunityHealthChoice(row.carrierName)) {
      body = t(lang, 'email.community.body');
    } else {
      body = t(lang, 'email.tpl1.body');
    }
  }

  const params = [];
  if (cc) params.push(`cc=${encodeMailtoValue(cc)}`);
  params.push(`subject=${encodeMailtoValue(subject)}`);
  params.push(`body=${encodeMailtoValue(body)}`);
  return `mailto:${to}?${params.join('&')}`;
}
